import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MenuComponent } from '../MenuComponent';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import LH_UpdateHoldLocation from '../../components/LinenhouseXdoc/LH_UpdateHoldLocation';
import * as MySound from '../MySound';

export class LH_Pallet extends Component {
    static displayName = LH_Pallet.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            scannedSSCC: "",
            scannedDebtor: "",
            scannedPutawayloc: "",
            scannedCartonType: "",
            enteredPutawayloc: "",
            selectedContainerRef: "",
            displayHoldBtn: false,
            newHoldLocation: "",
            displayUpdateLocationPrompt: false
        };

    }

    componentDidMount() {
        this.refs.putAwaylocInput.focus();
        if (this.props.location && this.props.location.state) {
            this.setState({
                scannedSSCC: this.props.location.state.scannedSSCC,
                scannedDebtor: this.props.location.state.scannedDebtor,
                scannedPutawayloc: this.props.location.state.scannedPutawayloc,
                scannedCartonType: this.props.location.state.scannedCartonType,
                selectedContainerRef: this.props.location.state.selectedContainerRef,
                displayHoldBtn: this.props.location.state.scannedCartonType.trim().toUpperCase() === "HOLD" ? true : false
            });
        }


    }
    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }
    validateBarcode() {
        this.setState({ alertMessage: "" });
        if (!this.state.enteredPutawayloc || this.state.enteredPutawayloc == "") {
            this.resetPutAwaylocInputInput("Please scan a valid location");
            return;
        }
        this.state.enteredPutawayloc = this.state.enteredPutawayloc.trim();
        var barCodeFormat = this.state.enteredPutawayloc.split("-");
        if (!barCodeFormat || barCodeFormat.length !== 4)
        {
            this.resetPutAwaylocInputInput("Invalid Location!! Location should be of this format : Stage-01-01-09");
            return;
        }

        if (this.state.enteredPutawayloc.trim().toUpperCase() !== this.state.scannedPutawayloc.trim().toUpperCase()) {
            this.resetPutAwaylocInputInput("Wrong Pallet");
            return;
        }

        fetch(`api/LinenhouseXdoc/ReceiptSSCC?sscc=${this.state.scannedSSCC}&location=${this.state.enteredPutawayloc}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const receiptResult = apiResponse.data;
                        if (apiResponse.success && receiptResult === true) {

                            MySound.play(MySound.Sound.next);
                            this.setState({enteredPutawayloc: "" });
                            this.goto('../LinenhouseXdoc/LH_Rows');

                        }
                        else {
                            //TODO: Check with Bruce about the wording of this message
                            MySound.play(MySound.Sound.stop);
                            this.setState({ alertMessage: "Failed to Receipt SSCC!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        MySound.play(MySound.Sound.stop);
                        this.setState({ alertMessage: "Failed to Receipt SSCC!!" });
                    }
                }

            })
            .catch(error => {
                MySound.play(MySound.Sound.stop);
                this.setState({ alertMessage: error });
            });

        

    }
   
    resetPutAwaylocInputInput(errorMessage) {
        MySound.play(MySound.Sound.stop);
        this.setState({ enteredPutawayloc: "", alertMessage: errorMessage });
        this.refs.putAwaylocInput.focus();
    }
    handleCloseModal(updatedLoc) {
        this.setState({ scannedPutawayloc: updatedLoc, displayUpdateLocationPrompt: false });
    }
    render() {
        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        let displayPrompt = this.state.displayUpdateLocationPrompt;
        displayPrompt = displayPrompt === true ? <LH_UpdateHoldLocation show={this.state.displayUpdateLocationPrompt} updateLocationData={this.state} onClickClose={(updatedLoc) => { this.handleCloseModal(updatedLoc); }}  ></LH_UpdateHoldLocation> : "";


        const handleKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.validateBarcode();
            }
        };
        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h4>GOTO Pallet</h4></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../LinenhouseXdoc/LH_Rows'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3" >
                        <Col xs={9}><h5><label>{this.state.scannedPutawayloc}</label></h5></Col>
                        <Col xs={3}>
                            <button type="button" className="btn btn-success col-12 mb-2"
                                style={{ display: this.state.displayHoldBtn === true ? 'block' : 'none' }}
                                onClick={(e) => {this.setState({ displayUpdateLocationPrompt: true });}}>Create Hold PLT</button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <input ref="putAwaylocInput" className="form-control" placeholder="Put Away Location" value={this.state.enteredPutawayloc}
                                onChange={(e) => {
                                    this.setState({ enteredPutawayloc: e.target.value });
                                }} onKeyPress={handleKeyPress} readOnly={this.state.loading} >
                            </input>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}><label className="font-weight-bold" >Store ID :</label></Col>
                        <Col xs={9}><label>{this.state.scannedDebtor}</label></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}><label className="font-weight-bold">Crossdock :</label></Col>
                        <Col xs={9}><label>{this.state.scannedCartonType === "XDOCK" ? "Yes" : "No"}</label></Col>
                    </Row>
                </Container>
                {displayPrompt}
            </div>

        );
    }


}
